export default {
  button: 'Grabar Contraseña',
  newPassword: 'Nueva Contraseña',
  confirm: 'Confirmar Contraseña',
  doesntMatch: "Las contraseña son diferentes",
  setPassword: 'Confirmar Contraseña'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/reset/en.js